/**
 * Counted nouns: "1 page", "575 reports" (task 453).
 *
 * "575 reports on 1 pages" is what a template string with a fixed plural
 * gives, so a count rendered beside its noun goes through here. `plural`
 * chooses the word alone, for a sentence that places the number itself;
 * `countOf` writes both, through `formatNumber` unless told otherwise.
 * English only, like every other string in the dashboard.
 */

import { formatNumber } from "./format-number";

/** "page" for one, "pages" otherwise, zero included. */
export function plural(count: number, one: string, many = `${one}s`): string {
  return count === 1 ? one : many;
}

interface CountOfOptions {
  /** The plural when it is not `one` plus "s": "entries". */
  many?: string;
  /** How the number is written; `formatNumber` by default. */
  format?: (count: number) => string;
}

/** "1 page", "1,234 pages", "1.2K reports" with `formatCompactNumber`. */
export function countOf(
  count: number,
  one: string,
  options: CountOfOptions = {},
): string {
  const { many, format = formatNumber } = options;
  return `${format(count)} ${plural(count, one, many)}`;
}
